const skinVisualizer = (config = {}) => {
    return {
        skinTypes: [],
        bodyParts: [],
        ageParts: [],
        activeImage: "",
        activeCaption: "",
        visibleItemsDesktop: 16,
        visibleItemsMobile: 10,
        totalChildren: [],
        showNoResults: false,
        showMoreResults: true,
        toggleShowMore: true,
        componentStyle: config.componentStyle || "default",
        init() {
            this.getTotalChildren();
            this.checkShowMore();
            if (this.componentStyle === "masonry") {
                this.applyMasonryLayout();
            }
        },
        getIsMobile() {
            let mobileMediaQuery = "(max-width: 475px)";
            let isMobile = window.matchMedia(mobileMediaQuery);
            return isMobile.matches;
        },
        checkShowMore(increment = 0) {
            let isMobile = this.getIsMobile();
            if (isMobile) {
                this.$nextTick(() => {
                    this.visibleItemsMobile += increment;
                    this.showMoreResults = this.visibleItemsMobile < this.totalChildren.length;
                });
            } else {
                this.$nextTick(() => {
                    this.visibleItemsDesktop += increment;
                    this.showMoreResults = this.visibleItemsDesktop < this.totalChildren.length;
                });
            }
        },
        getTotalChildren() {
            let allChildren = this.$refs.gallery.querySelectorAll(".galleryImage");
            this.totalChildren = Array.from(allChildren);
            this.$nextTick(() => {
                let countLimit = 5;
                // show no results text if total children = 0
                this.totalChildren.length === 0 ? (this.showNoResults = true) : (this.showNoResults = false);
                // hide bottom background if results < counterLimit
                this.totalChildren.length < countLimit ? this.$refs.skinVisualizer.classList.add("hideBottom") : this.$refs.skinVisualizer.classList.remove("hideBottom");
            });
        },

        showItem() {
            this.getTotalChildren();
            let isMobile = this.getIsMobile();
            let maxAmount = isMobile ? this.visibleItemsMobile : this.visibleItemsDesktop;

            return this.totalChildren.indexOf(this.$el) < maxAmount;
        },
        showImage(skinCategory, bodyCategory, ageCategory) {
            const isSkinFilterOff = this.skinTypes.length == 0;
            const isBodyFilterOff = this.bodyParts.length == 0;
            const isAgeFilterOff = this.ageParts.length == 0;
            const isSkinFilterSelected = this.skinTypes.includes(skinCategory);
            const isBodyFilterSelected = this.bodyParts.includes(bodyCategory);
            const isAgeFilterSelected = this.ageParts.includes(ageCategory);

            if (isSkinFilterOff && isBodyFilterOff && isAgeFilterOff) {
                this.checkShowMore();
            }

            return (
                (isSkinFilterOff || isSkinFilterSelected) &&
                (isBodyFilterOff || isBodyFilterSelected) &&
                (isAgeFilterOff || isAgeFilterSelected)
            );
        },
        resetVisibleItems() {
            this.visibleItemsDesktop = 16;
            this.visibleItemsMobile = 10;

            this.$nextTick(() => {
                this.getTotalChildren();
                this.checkShowMore();
                if (this.componentStyle === "masonry") {
                    this.applyMasonryLayout();
                }
            });
        },
        increaseVisibleItems() {
            let isMobile = this.getIsMobile();
            let incrementAmount = isMobile ? 2 : 8;
            this.checkShowMore(incrementAmount);
            this.$nextTick(() => {
                this.updateMasonryLayout();
            });
        },
        triggerEnter() {
            let elem = this.$el;
            elem.click();
        },
        launchModal() {
            $("#galleryModal").modal("show");
        },
        focusNextElement() {
            let elem = this.$el;
            if (elem.parentNode.nextElementSibling) elem.parentNode.nextElementSibling.querySelector("input").focus();
        },
        focusPrevElement() {
            let elem = this.$el;
            if (elem.parentNode.previousElementSibling) elem.parentNode.previousElementSibling.querySelector("input").focus();
        },
        applyMasonryLayout() {
            if (this.componentStyle !== "masonry") return;

            const gridSpanClasses = {
                even: ["spanRow2Col2", "spanRow1Col2", "spanRow1Col1", "spanRow1Col1"],
                odd: ["spanRow1Col2", "spanRow2Col2", "spanRow1Col1", "spanRow2Col1"]
            };
            const allClasses = ["spanRow2Col2", "spanRow1Col2", "spanRow1Col1", "spanRow2Col1"];

            this.$nextTick(() => {
                const allGalleryItems = Array.from(this.$refs.gallery.querySelectorAll(".galleryImage"));

                // Clear all masonry classes from all items first
                allGalleryItems.forEach(item => {
                    item.classList.remove(...allClasses);
                });

                const isMobile = this.getIsMobile();
                const maxAmount = isMobile ? this.visibleItemsMobile : this.visibleItemsDesktop;

                const visibleGalleryItems = allGalleryItems.filter(item => {
                    return this.totalChildren.indexOf(item) < maxAmount;
                });

                const groupedItems = [];
                for (let i = 0; i < visibleGalleryItems.length; i += 4) {
                    groupedItems.push(visibleGalleryItems.slice(i, i + 4));
                }
                groupedItems.forEach((group, idx) => {
                    const gridSpanClassArray = idx === 0 || idx % 2 === 0 ? gridSpanClasses.even : gridSpanClasses.odd;
                    group.forEach((item, itemIdx) => {
                        item.classList.add(gridSpanClassArray[itemIdx]);
                    });
                });
            });
        },
        resetFilters() {
            this.skinTypes = [];
            this.bodyParts = [];
            this.ageParts = [];
            this.resetVisibleItems();
        },
        isResetFilterDisabled() {
            return this.skinTypes.length === 0 && this.bodyParts.length === 0 && this.ageParts.length === 0;
        },
        updateMasonryLayout() {
            if (this.componentStyle === "masonry") {
                this.applyMasonryLayout();
            }
        }
    };
};

export default skinVisualizer;
